import { Pipe, PipeTransform, Optional } from '@angular/core';
import { I18nService } from './i18n.service';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
    constructor(@Optional() public i18nService: I18nService) { }
    transform(name: any, defaultVal = ''): any {
        if (this.i18nService) {
            const r = this.i18nService.getValue(name);
            return r ? r : defaultVal;
        } else {
            return defaultVal;
        }
    }
}
